import { getItemIdFromArgsConfig } from '../utils/event_constants';

export const modalActions = [
  {
    name: 'showModal',
    label: 'Open Modal',
    args: [
      {
        name: 'modal',
        label: 'Modal',
        type: 'dropdown',
        optionsType: 'modalApi',
        value: '',
      },
      ...getItemIdFromArgsConfig,
      {
        name: 'enableMultiSelect',
        label: 'Enable Bulk Selection (append Selected Item Ids to Form)',
        type: 'boolean',
        value: '',
        custom: [],
      },
    ],
  },
  {
    name: 'closeModal',
    label: 'Close Modal',
    args: [],
  },
  {
    name: 'conditionalOpenModal',
    label: 'Conditional Open Modal',
    args: [
      {
        name: 'collectionFrom',
        label: 'Collection From',
        type: 'radio',
        optionsType: '',
        value: 'collections',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'collectionName',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldName',
        label: 'Collection Field',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'displaySubPage',
    label: 'Show Sub Page',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'hideComponentPageApi',
        value: '',
      },
      {
        name: 'pageSubPageComponents',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageSubPageComponentApi',
        options: [],
        value: '',
      },
      {
        name: 'subPage',
        label: 'Sub Page',
        type: 'dropdown',
        optionsType: 'subPageApi',
        value: '',
      },
      ...getItemIdFromArgsConfig,
    ],
  },
  {
    name: 'conditionalOpenSubpage',
    label: 'Conditional Open Subpage',
    args: [
      {
        name: 'collectionFrom',
        label: 'Collection From',
        type: 'radio',
        optionsType: '',
        value: 'collections',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      {
        name: 'collectionName',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'fieldName',
        label: 'Collection Field',
        type: 'dropdown',
        optionsType: 'collectionConstructorApi',
        options: [],
        value: '',
      },
      {
        name: 'pageFrom',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'showComponentPageApi',
        value: '',
      },
      {
        name: 'pageSubPageComponents',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageSubPageComponentApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'displayCustomComponent',
    label: 'Show Custom Component',
    args: [
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'showComponentPageApi',
        value: '',
      },
      {
        name: 'pageCustomComponentComponents',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageCustomComponentComponentApi',
        options: [],
        value: '',
      },
      {
        name: 'customComponent',
        label: 'Custom Component',
        type: 'dropdown',
        optionsType: 'customComponentApi',
        value: '',
      },
    ],
  },
  {
    name: 'displayToolTip',
    label: 'Display Tooltip',
    args: [
      {
        name: 'toolTip',
        label: 'ToolTip Template',
        type: 'dropdown',
        optionsType: 'toolTipApi',
        options: [],
        value: '',
      },
      {
        name: 'placement',
        label: 'Position',
        type: 'dropdown',
        optionsType: 'toolTipPosition',
        options: [],
        value: '',
      },
      {
        name: 'theme',
        label: 'Theme',
        type: 'dropdown',
        optionsType: 'toolTipTheme',
        options: [],
        value: '',
      },
      {
        name: 'animation',
        label: 'Animation',
        type: 'dropdown',
        optionsType: 'toolTipAnimation',
        options: [],
        value: '',
      },
      {
        name: 'followCursor',
        label: 'Follow Cursor',
        type: 'dropdown',
        optionsType: 'toolTipFollowCursor',
        options: [],
        value: '',
      },
      {
        name: 'maxWidth',
        label: 'Max Width',
        type: 'number',
        value: '',
      },
      {
        name: 'showDelay',
        label: 'Show Delay',
        type: 'number',
        value: '',
      },
      {
        name: 'hideDelay',
        label: 'Hide Delay',
        type: 'number',
        value: '',
      },
      {
        name: 'interactive',
        label: 'Interactive',
        type: 'boolean',
        value: '',
      },
    ],
  },
  {
    name: 'openFloatingModal',
    label: 'Open Floating Modal',
    args: [
      {
        name: 'floatingModalId',
        label: 'Floating Modal',
        type: 'dropdown',
        optionsType: 'floatingModalApi',
        value: '',
      },
      ...getItemIdFromArgsConfig,
      {
        name: 'fmPosition',
        label: 'Position (Optional)',
        type: 'fmPosition',
        optionsType: 'fmPositionOptionsApi',
        options: [],
        value: 'center',
      },
      {
        name: 'fmDraggable',
        label: 'Draggable',
        type: 'boolean',
        value: true,
        custom: [],
      },
      {
        name: 'fmHeight',
        label: 'Height',
        type: 'number',
        value: 500,
        custom: [],
      },
      {
        name: 'fmWidth',
        label: 'Width',
        type: 'number',
        value: 500,
        custom: [],
      },
      {
        name: 'fmClosable',
        label: 'Closable',
        type: 'boolean',
        value: true,
        custom: [],
      },
      {
        name: 'fmResizable',
        label: 'Resizable',
        type: 'boolean',
        value: true,
        custom: [],
      },
      {
        name: 'fmMinimizable',
        label: 'Minimizable',
        type: 'boolean',
        value: true,
        custom: [],
      },
      // {
      //   name: 'enableMultiSelect',
      //   label: 'Enable Bulk Selection (append Selected Item Ids to Form)',
      //   type: 'boolean',
      //   value: '',
      //   custom: [],
      // },
    ],
  },
];
